import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { socialLinks } from '../data';

const Hero = () => {
  return (
    <section className="container">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="hero-content"
      >
        <p className="hero-overline">Hi, my name is</p>
        <h1 className="hero-title">Petar Gjuzelov.</h1>
        <h2 className="hero-subtitle">Web Developer | React, Vue, & Next.js</h2>
        <p className="hero-description">
          I am a Web Developer with over 3 years of experience in creating responsive, user-friendly web applications...
        </p>

        <div className="hero-socials">
          <a href={socialLinks.github} target="_blank" rel="noreferrer" className="hero-social-link" title="GitHub">
            <FaGithub />
          </a>
          <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" className="hero-social-link" title="LinkedIn">
            <FaLinkedin />
          </a>
          <a href={`mailto:${socialLinks.email}`} className="hero-social-link" title="Email">
            <FaEnvelope />
          </a>
        </div>

        <a href="#projects" className="btn">Check out my work!</a>
      </motion.div>
    </section>
  );
};

export default Hero;